export default __webpack_public_path__ + "static/media/Atm.aec75bea.png";